import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import * as RestService from '../../services/eisRest';





  const ChangePasswordModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
   
  
    const hideModal = () => {
      setIsOpen(false);     
      props.parentCallback(false);
    };

   

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);     

    }, [props.modal])

    
   

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      
      RestService.callAnyApi(url,null)
          .then((data) => {  
                   if(data.responseMessage==='OK'){
                      toast.success(t('general.message.saveSucceed'));     
                      hideModal();                                                                 
                  }else{
                      showError(null,t('general.message.'+data.responseMessage));
                  }                                               
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
       
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      validationSchema: Yup.object({
        oldPassword: Yup.string()     
          .nullable()
          .min(5, t('login.label.min5Char'))
          .max(30, t('login.label.max30Char'))
          .required(t('general.message.required')),
        newPassword: Yup.string()     
           .nullable()           
           .min(5, t('login.label.min5Char'))
           .max(30, t('login.label.max30Char'))
           .required(t('general.message.required')),
        confirmPassword: Yup.string()     
           .nullable()          
           .min(5, t('login.label.min5Char'))
          .max(30, t('login.label.max30Char'))
          .required(t('general.message.required'))
          .oneOf([Yup.ref('newPassword'), null], t('general.message.newAndConfirmPasswordNotSame'))
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('user/setPassword?userId='+props.userId+"&oldPassword="+values.oldPassword+"&newPassword="+values.newPassword,values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    size="sm"                    
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('user.label.changePassword')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                          <div className="row"> 
                                <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('user.label.oldPassword')}</label>
                                    <input type="password" class="form-control"  placeholder="" {...formik.getFieldProps('oldPassword')} />
                                  </div>
                                  {formik.touched.oldPassword && formik.errors.oldPassword ? (
                                    <div style={{ color: 'red' }}>{formik.errors.oldPassword}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row"> 
                                <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('user.label.newPassword')}</label>
                                    <input type="password" class="form-control"  {...formik.getFieldProps('newPassword')} />
                                  </div>
                                  {formik.touched.newPassword && formik.errors.newPassword ? (
                                    <div style={{ color: 'red' }}>{formik.errors.newPassword}</div>
                                ) : null} 
                                </div>        
                          </div>
                     

                          <div className="row"> 
                                <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('user.label.confirmPassword')}</label>
                                    <input type="password" class="form-control"  {...formik.getFieldProps('confirmPassword')} />
                                  </div>
                                  {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                    <div style={{ color: 'red' }}>{formik.errors.confirmPassword}</div>
                                ) : null} 
                                </div>        
                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                                                                         
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
             
             
      </>
    );
  };

 export default ChangePasswordModal;